var _style, _g, _rect, _rect2, _rect3, _rect4, _polygon, _g2, _g3, _g4, _g5, _g6, _g7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 8503.9 5102.4",
    style: {
      enableBackground: "new 0 0 8503.9 5102.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#50B848;}\r\n\t.st1{fill:#0095DA;}\r\n\t.st2{fill:#92278F;}\r\n\t.st3{fill:#ED1C24;}\r\n\t.st4{fill:#F37021;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4865,3080.8l-557.3-1v-965.1h-210.1v1176.5h967.9C4982.4,3238.9,4913.3,3166.5,4865,3080.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2655.7,2114.7v1176.5h-210.1v-749.6l-206.7,158l-171.4,132.8L1896,2699.6l-206.7-158v749.6h-210.1V2114.7 l210.1,161.4l378.2,290.8l378.2-290.8L2655.7,2114.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3976.7,3291.2h-235.3l-107.6-210.1l-257.2-504.2l-257.2,504.2l-107.6,210.1h-235.3l107.6-210.1l492.5-966.4 l492.5,966.4L3976.7,3291.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6046.9,2114.7v588.3c0,324.4-263.9,588.3-588.3,588.3c-324.4,0-588.3-263.9-588.3-588.3v-588.3h210.1v588.3 c0,208.4,169.8,378.2,378.2,378.2c208.4,0,378.2-169.8,378.2-378.2v-588.3H6046.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6831.7,2587l509.3,704.2h-258.8l-406.7-561.4l-297.5,270.6v290.8h-210.1V2114.7h210.1v601.7l173.1-158 l156.3-142.9l327.8-300.9H7346L6831.7,2587z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7466.9,3291.2V2114.7H7677v1176.5H7466.9z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1222.6,
    y: 3183,
    className: "st1",
    width: 135.7,
    height: 108.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1057,
    y: 3014.1,
    className: "st2",
    width: 301.3,
    height: 108.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 921.2,
    y: 2845.2,
    className: "st3",
    width: 437.1,
    height: 108.2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 991.9,
    y: 2676.3,
    className: "st4",
    width: 366.3,
    height: 108.2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1358.3,2615.6 1358.3,2507.4 826.9,2507.4 826.9,2615.6 "
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.223e8111.svg";
export { ForwardRef as ReactComponent };